'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var MenuItem = _interopDefault(require('@material-ui/core/MenuItem'));
var IconButton = _interopDefault(require('@material-ui/core/IconButton'));
var styledComponents = require('./styled-components.js');

var NewButtonWithDropDown = function (props) {
    var _a = React__default.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var menuItems = props.menuItems, Icon = props.Icon, id = props.id;
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var setClick = function (arg0) {
        return function () {
            arg0();
            handleClose();
        };
    };
    return (React__default.createElement("div", { style: { display: 'inline-block' } },
        React__default.createElement(IconButton, { onClick: handleClick },
            React__default.createElement(Icon, null)),
        React__default.createElement(styledComponents, { id: id, anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, menuItems.map(function (item) { return (React__default.createElement(MenuItem, { key: item.text, onClick: setClick(item.clickHandler) }, item.text)); }))));
};

module.exports = NewButtonWithDropDown;
